import { useEffect, useState } from "react";
import Lenis from "@studio-freight/lenis";

export default function SmoothScroll() {
  const [isMouse, setIsMouse] = useState(false);

  useEffect(() => {
    let wheelTimeout = null;

    const detectInputDevice = (e) => {
      // Throttle wheel event to avoid frequent updates
      clearTimeout(wheelTimeout);
      wheelTimeout = setTimeout(() => {
        // Trackpad has subtle, small scroll events (deltaY ~ 1-2)
        if (Math.abs(e.deltaY) > 10) {
          setIsMouse(true); // Likely a mouse scroll
        } else {
          setIsMouse(false); // Likely a trackpad scroll
        }
      }, 50); // Throttle wheel event to every 50ms
    };

    window.addEventListener("wheel", detectInputDevice, { passive: true });

    return () => {
      window.removeEventListener("wheel", detectInputDevice);
      clearTimeout(wheelTimeout);
    };
  }, []);

  useEffect(() => {
    // Apply Lenis effect only for mouse scroll input
    if (isMouse) {
      const lenis = new Lenis({
        duration: 0.1, // Duration for smooth scroll (feel free to adjust)
        easing: (t) => t, // Easing function for smooth transition
        smooth: true, // Activate smooth scrolling
      });

      function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }

      requestAnimationFrame(raf);

      return () => {
        lenis.destroy();
      };
    }
  }, [isMouse]); // Only runs when isMouse changes

  return null;
}
